module.exports = __webpack_public_path__ + "static/media/bio_danielle.8267652b.jpg";